import PieChart from "components/charts/PieChart";
import { pieChartData, pieChartOptions } from "variables/charts";
import Card from "components/card";
import React, {useEffect, useState} from "react";
import useAsyncEffect from "use-async-effect";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {
  MdDashboard,
  MdEmail,
  MdInsertInvitation,
  MdPhone,
  MdPhoneAndroid,
  MdPhoneIphone,
  MdRequestPage,
  MdShare
} from "react-icons/md";
import Widget from "../../../../components/widget/Widget";
import Widget2 from "../../../../components/widget/Widget2";

const SharedUserStatsTextSection = () => {

  const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
  const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

  //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
  //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
  const secretKey = "cromptonssecretkey";

  let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
  const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
  const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
  const navigate = useNavigate();

  let [dataCount, setDataCount] = useState([]);
  let [options, setOptions] = useState([]);


  const [pieChartDataValues, setPieChartData] = useState([]);
  const [unit, setUnits] = useState([]);

  var sharedUserStat = []
  var sharedUserStatNumber = []

  const [errorMessage, setErrorMessage] = useState("")

  const handleLogOut = async () => {
    try {
      await logOut();
      navigate("/");
    } catch (error) {
      ////console.log(error.message);
    }
  }

  async function getSharedUserAnalytics() {
    if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "3") || (accesscontrollevel.toString() === "4") || (accesscontrollevel.toString() === "5")) {
      var chartLabels = [];
      var count = [];
      var url = CROMPTON_ANALYTICS_URL + "v1/user/sharedUsers"
      //console.log("URL: ", url)
      var arrlabels = [];
      await axios({
        method: "GET", url: url, headers: {
          Authorization: decryptedValue,
        }


      }).then((res) => {
        setErrorMessage("")

        for (var i in res.data) {
          //conventional key and value are switched as two products with same p_name
          sharedUserStat.push(i);
          sharedUserStatNumber.push(res.data[i])
        }

        sharedUserStatNumber.splice(3, 3)
        setDataCount(sharedUserStatNumber)

        //console.log(sharedUserStatNumber)

        /*console.log("Data labels: ", chartLabels)
        console.log("Data values: ", count)*/

      }).catch((error) => {
        setErrorMessage(error.response.data.message)
        if (error.response.data.status === "401" || error.response.data.status === "403") {
          handleLogOut();
        }
      })

    } else {
      //console.log("Inside stats non admin")
    }
  }

  useAsyncEffect( () => {

    getSharedUserAnalytics()

    /*units =JSON.parse(localStorage.getItem("units"))
    unitCounts = JSON.parse(localStorage.getItem("unitCounts"))*/


  }, [""])
  return (
      <Card extra="rounded-[20px] p-3">
        <div className="flex flex-row justify-between px-3 pt-2">
          <div>
            <h4 className="text-lg font-bold text-navy-700 dark:text-white">
              Shared User Analytics
            </h4>
          </div>
        </div>

        <br/>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-1 3xl:grid-cols-2">

          <div>
            <h4 className="text-lg font-bold text-navy-700 dark:text-white">
              Total Shared Users:
            </h4>
          </div>

          <div>
            <h4 className="text-lg font-bold text-navy-700 dark:text-white">
              {dataCount[0]}
            </h4>
          </div>

          <Widget2
              icon={<MdPhoneIphone className="h-6 w-6 text-[#004c86] dark:text-white"/>}
              title={"Mobile Invited Users: "}
              subtitle={dataCount[1]}
          />
          <Widget2
              icon={<MdEmail className="h-6 w-6 text-[#004c86] dark:text-white"/>}
              title={"Email Invited Users: "}
              subtitle={dataCount[2]}
          />
          <Widget2
              icon={<MdInsertInvitation className="h-6 w-6 text-[#004c86] dark:text-white"/>}
              title={"Invited Users: "}
              subtitle={dataCount[3]}
          />
          <Widget2
              icon={<MdShare className="h-6 w-6 text-[#004c86] dark:text-white"/>}
              title={"Shared Homes: "}
              subtitle={dataCount[4]}
          />

        </div>
      </Card>
  );
};

export default SharedUserStatsTextSection;
